
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicules-tourisme/[slug]",
      function () {
        return require("private-next-pages/vehicules-tourisme/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicules-tourisme/[slug]"])
      });
    }
  